/* eslint-disable */
import requestDev from '@/utils/requestDev'
import requestRawBasic from '@/utils/requestRawBasic'
import requestRawJWT from '@/utils/requestRaw'
import { APICore, APIReportPHP } from '@/utils/servicesApi'
const qs = require('qs')

export function voucherList(params) {
  return requestDev({
    url: APIReportPHP() + '/zeus/order/voucher-list',
    method: 'POST',
    data: qs.stringify(params)
  })
}


export function orderList(params) {
  return requestDev({
    url: APIReportPHP() + '/zeus/order/list',
    method: 'POST',
    data: qs.stringify(params)
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js